export const permissions = (state) => state.permissions
export const user = (state) => state.user
